import {
  FETCH_WORKFLOW_STATUS_LIST,
  FETCH_WORKFLOW_STATUS_LIST_SUCCESS,
  FETCH_WORKFLOW_STATUS_LIST_FAIL,
  UPDATE_WORKFLOW_STATUS_LIST,
  UPDATE_WORKFLOW_STATUS_LIST_SUCCESS,
  UPDATE_WORKFLOW_STATUS_LIST_FAIL,
  CLOSE_SUCCESS_MODAL
} from '../../actions/cm/workFlowStatus';

export const initialState = {
  isLoading: false,
  hasError: false,
  workFlowStatusList: [],
  errorMessage: '',
  success: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_WORKFLOW_STATUS_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_WORKFLOW_STATUS_LIST_SUCCESS:
      return {
        ...state,
        workFlowStatusList: payload,
        isLoading: false
      };
    case FETCH_WORKFLOW_STATUS_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case UPDATE_WORKFLOW_STATUS_LIST:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case UPDATE_WORKFLOW_STATUS_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        success: true
      };
    case UPDATE_WORKFLOW_STATUS_LIST_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case CLOSE_SUCCESS_MODAL:
      return {
        ...state,
        success: false
      };
    default:
      return state;
  }
}
